module.exports = __webpack_public_path__ + "static/osvedceni-8a2ab26282cd7ecd2be1699753f1919e.pdf";